import { useCallback, useEffect, useMemo, useState } from "react";
import { calculateTimerMs } from "./liveMatchNormalizer";
import { getLiveMatchChannel } from "./liveMatchStore";

/**
 * `tickTimer` yalnızca sayacı canlı gösteren ekranlar için açılır. Kapalıyken
 * `timerMs` yalnızca sayaç durumu değişince hesaplanır; böylece kendi saatini
 * çizen kaplamalar ve reji paneli saniyede 4 kez baştan çizilmez.
 */
export default function useLiveMatchChannel(matchId, { tickTimer = false } = {}) {
  const channel = getLiveMatchChannel(matchId);
  const [state, setState] = useState(() => channel?.getSnapshot() || null);
  const [timerMs, setTimerMs] = useState(() => calculateTimerMs(state?.timer));
  useEffect(() => {
    if (!channel) { setState(null); return undefined; }
    setState(channel.getSnapshot());
    return channel.subscribe(() => setState(channel.getSnapshot()));
  }, [channel]);
  useEffect(() => {
    if (!tickTimer || !state?.timer?.running) { setTimerMs(calculateTimerMs(state?.timer)); return undefined; }
    let frame; let last = 0;
    const tick = now => { if (now - last >= 250) { last = now; setTimerMs(calculateTimerMs(state.timer)); } frame = requestAnimationFrame(tick); };
    frame = requestAnimationFrame(tick); return () => cancelAnimationFrame(frame);
  }, [state?.timer, tickTimer]);
  const refreshSnapshot = useCallback(reason => channel?.refreshSnapshot(reason), [channel]);
  // Dönen nesne yalnızca durum ya da sayaç değişince yenilenir; aksi hâlde her
  // çizimde yeni nesne üretilir ve tüketicilerdeki useMemo/useEffect boşa döner.
  return useMemo(
    () => (state ? { state, ...state, timerMs, refreshSnapshot, mutations: {} } : { state: null, timerMs: 0, refreshSnapshot, mutations: {} }),
    [state, timerMs, refreshSnapshot]
  );
}
